import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ec2c4c7e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=ec2c4c7e&prod&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=ec2c4c7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2c4c7e",
  null
  
)

export default component.exports